import { JobStatus } from '@mi-front/core';
import { AudiogramGenerationVariantJobSnapshotDto } from '@app/modules/fragments/fragment.types';
import { MessageDescriptor } from 'react-intl';
import { Fragment } from '../../../../types';
import { AUDIOGRAM_TARGET_VARIANTS } from './consts';

export type VariantWithJob = {
  variant: string;
  job: AudiogramGenerationVariantJobSnapshotDto;
};

function isGenerationStarted(fragment: Fragment) {
  return !!Object.values(fragment.audiogramGeneration?.variantsJobs ?? {}).length;
}

function getFailedVariants(fragment: Fragment): VariantWithJob[] {
  return Object.entries(fragment.audiogramGeneration?.variantsJobs ?? {})
    .filter(([_, job]) => job.status === JobStatus.FAILED)
    .map(([variant, job]) => ({ variant, job }));
}

function getInProgressVariants(fragment: Fragment): VariantWithJob[] {
  return Object.entries(fragment.audiogramGeneration?.variantsJobs ?? {})
    .filter(([_, job]) => job.status === JobStatus.IN_PROGRESS)
    .map(([variant, job]) => ({ variant, job }));
}

function getCompletedVariants(fragment: Fragment): VariantWithJob[] {
  return Object.entries(fragment.audiogramGeneration?.variantsJobs ?? {})
    .filter(([_, job]) => job.status === JobStatus.COMPLETED)
    .map(([variant, job]) => ({ variant, job }));
}

function getVariantName(variant: string, formatMessage: (msg: MessageDescriptor) => string) {
  const entry = AUDIOGRAM_TARGET_VARIANTS.find((v) => v.value === variant);
  return entry ? formatMessage(entry.message) : variant;
}

export const audiogramHelpers = {
  isGenerationStarted,
  getFailedVariants,
  getCompletedVariants,
  getInProgressVariants,
  getVariantName,
};
